import { createFileRoute } from '@tanstack/react-router'
import { CertificationRequestsPage } from '@/features/certification/pages/certification-requests-page'

export const Route = createFileRoute('/_authenticated/_sidebar/observer/certification-requests')({
  component: CertificationRequests,
})

function CertificationRequests() {
  return <CertificationRequestsPage />
}

